import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ProductStoreComponent } from './product-store.component';
import { NbMenuItem } from '@nebular/theme';
import { UbsViewContainersModule, ViewContainersService } from '@urbannex/view-containers';
import { MenuItemNavigatorComponent } from '@urbannex/kwikstore-visual-editor/src/lib/editors/navigation-editor/navigation-input/menu-item-navigator/menu-item-navigator.component';

export const routes: Routes = [
  {
    path:'',
    component:ProductStoreComponent,
  }
 
]

const MENU_ITEMS:NbMenuItem[] = [];
const headerTitle:string = "PRODUCT STORE";
const path:string = "product-store";
const menuTag:string = "productStoreMenu"


@NgModule({
  //declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    UbsViewContainersModule
  ]

})
export class ProductStoreRoutingModule {
  menuAndTitleOptions = {path:path,menuItems:MENU_ITEMS,headerTitle:headerTitle,menuTag:menuTag};
  constructor(private viewContainerService:ViewContainersService){
    let currentItems = this.viewContainerService.menuAndTitleOptions$.getValue();
    console.log(currentItems);
    let updated = currentItems.concat(this.menuAndTitleOptions);
    this.viewContainerService.menuAndTitleOptions$.next(updated);
    //this.viewContainerService.menuAndTitleOptions$.next(this.viewContainerService.menuAndTitleOptions$.getValue().concat([this.menuAndTitleOptions]));
    this.viewContainerService.activeMenuTag$.next(menuTag);
    //this.viewContainerService.addMenuAndTitleOptions(menuAndTitleOptions)
  }
 }
